/**
 * Created by zad on 17/10/26.
 */
import React, { Component } from 'react';
import i18n from 'react-intl-universal';
import getComponentName from '../utils/getComponentName';

import Loading from '../components/Loading';

// 基于属性代理的HOC
export default checkFn => options => (WrapperComponent) => {
  return class withLoading extends Component {
    static displayName = `withLoading(${getComponentName(WrapperComponent)})`;

    render() {
      const { tip, size, delay, hasMask, wrapperClassName } = options || {};
      let tipText = '';
      try {
        tipText = i18n.get(tip).d(tip);
      } catch (e) {
        // 如果国际化键不存在，则使用默认值或空字符串
        tipText = tip || '';
      }

      return (
        <Loading
          loading={checkFn(this.props)}
          size={size}
          tip={tipText}
          delay={delay}
          hasMask={hasMask}
          wrapperClassName={wrapperClassName}
        >
          <WrapperComponent {...this.props}/>
        </Loading>
      );
    }
  };
};


// WEBPACK FOOTER //
// ./src/HOC/withLoading.js